import { Outlet, Navigate } from "react-router";
import useGetRole from "@/hooks/useGetRole";

export default function ProtectedRoutes() {
    const { isAuthorized } = useGetRole();

    return isAuthorized ? <Outlet /> : <Navigate to='/' />;
}
